// extracted by mini-css-extract-plugin
export default {"wrapper":"AlphaCard_wrapper__ZE8AX","container":"AlphaCard_container__vTUlt","icon":"AlphaCard_icon__K-HQ-","iconPlaying":"AlphaCard_iconPlaying__iTUMo"};